<template>
  <div class="box">
    <el-container>
      <el-header>
        <headerList></headerList>
      </el-header>
      <el-main>
        <div class="pic">
          <div class="title">
            <div class="title-eng">Pension institutions</div>
            <div class="title-bold">养老机构</div>
          </div>
        </div>
        <div class="content">
          <div class="content-list">
            <div class="service-content" v-for="item in institutionsList">
              <div class="service-left">
                <el-image
                  style="width: 100%; height: 100%; vertical-align: middle"
                  :src="require('@/assets/image/bg0.jpeg')"
                ></el-image>
              </div>
              <div class="service-right">
                <div class="service-name">名称：{{item.mechanismName}}</div>
                <div class="service-type" v-if="item.mechanismType == 0">类型：养老机构</div>
                <div class="service-type" v-if="item.mechanismType == 1">类型：日间照料中心</div>
                <div class="service-type" v-if="item.mechanismType == 2">类型：幸福苑</div>
                <div class="service-type" v-if="item.mechanismType == 3">类型：合作服务商</div>
                <div class="service-type" v-if="item.mechanismType == 4">类型：其他</div>
                <div class="service-list">
                  <div class="service-tel">电话：{{item.hotline}}</div>
                  <div class="service-level">评级：{{item.grade}}</div>
                </div>
                <div class="service-bed">
                  <div class="service-allbed">总床位数：{{item.bedNum}}</div>
                  <div class="service-nonebed">空床位数：{{item.freeBedNum}}</div>
                </div>
                <div class="service-address">
                  地址：湖北省黄冈市XX区XX大道100号
                </div>
                <el-button class="apply" type="warning" round @click="appointment(2)"
                  >立即预约 →</el-button
                >
              </div>
            </div>
<!--           <div class="pageBtn">-->
<!--            <el-pagination-->
<!--              background-->
<!--              layout="prev, pager, next"-->
<!--              page-size="6"-->
<!--              :total="50"-->
<!--            >-->
<!--            </el-pagination>-->
<!--          </div>-->
          </div>
        </div>
      </el-main>
    </el-container>
  </div>
</template>

<script>
import headerList from "./public/header";

export default {
  name: "organization",
  components: { headerList },
  data() {
    return {
      userInfo: {
        id: "",
        username: "7777",
        avatar: "",
      },
      username: "",
      showMenu: false,
      wordtop: 0,
      institutionsList:'',
      flag: false,
      url: "https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg",
    };
  },
  created() {
    const userInfo = localStorage.getItem("userInfo");
    if (userInfo != null) {
      this.userInfo = JSON.parse(userInfo);
    }
    this.init();
  },
  mounted() {},
  methods: {
    handleScroll: function () {
      if (document.body.scrollTop != 0) {
        this.wordtop = document.body.scrollTop;
      } else {
        this.wordtop = document.documentElement.scrollTop;
      }
      if (this.wordtop > 800) {
        this.showMenu = true;
      } else {
        this.showMenu = false;
      }
    },
    beforeDestroy() {
      window.removeEventListener("scroll", this.handleScroll);
    },
    init(){
      var uid= 5;
      this.$axios
              .get("/wx/jg/list/"+uid, {
                params: {
                  // customerName: this.searchForm.name,
                  // customerName: this.current,
                  // phone: this.size,
                  // state:''
                },
              })
              .then((res) => {
                this.institutionsList = res.data.data.records;
              });
    },
    appointment(num){
      this.$router.push({
        name:'serviceList',
        // path:'/serviceList',
        query: {
          type: num
        }
      });
    },
  },
};
</script>

<style scoped>
.box {
  position: relative;
  top: 0;
  left: 0;
  padding: 0;
  margin: auto;
}
.el-container {
  padding: 0;
  margin: 0;
  width: 100%;
  height: 100%;
}
.el-header {
  width: 100%;
  height: 7.1875rem /* 115px -> 7.1875rem */ !important;
  line-height: 7.1875rem /* 115px -> 7.1875rem */;
  background-color: #fff;
  color: #333;
  text-align: center;
  position: fixed;
  background: rgba(255, 255, 255, 0.8);
  top: 0;
  left: 0;
  z-index: 99;
}

.el-main {
  color: #333;
  padding: 0;
  width: 100%;
}
.pic {
  width: 100%;
  height: 39.875rem /* 638px -> 39.875rem */;
  background: url("../assets/image/bg6.jpeg") no-repeat;
  background-size: 100% 100%;
  position: relative;
  left: 0;
  top: 0;
}
.title {
  width: 24.0625rem /* 385px -> 24.0625rem */;
  height: 7.9375rem /* 127px -> 7.9375rem */;
  position: absolute;
  bottom: 0;
  right: 16.375rem /* 262px -> 16.375rem */;
  background: #f77f00;
  opacity: 0.9;
  color: #fff;
}
.title-eng {
  width: 12.5625rem /* 201px -> 12.5625rem */;
  height: .8125rem /* 13px -> .8125rem */;
  font-size: 1rem /* 16px -> 1rem */;
  font-family: Arial;
  font-weight: bold;
  color: #ffffff;
  line-height: 3.75rem /* 60px -> 3.75rem */;
  margin-left: .9375rem /* 15px -> .9375rem */;
}
.title-bold {
  width: 10.0625rem /* 161px -> 10.0625rem */;
  height: 2.375rem /* 38px -> 2.375rem */;
  font-size: 2.375rem /* 38px -> 2.375rem */;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #ffffff;
  line-height: 6.6875rem /* 107px -> 6.6875rem */;
  margin-left: .9375rem /* 15px -> .9375rem */;
}
.content {
  height: 95.875rem /* 1534px -> 95.875rem */;
}
.content-list {
  margin: 5rem /* 80px -> 5rem */ 13.75rem /* 220px -> 13.75rem */;
}
.service-content {
  margin: .9375rem /* 15px -> .9375rem */;
  width: 43rem /* 688px -> 43rem */;
  height: 22.8125rem /* 365px -> 22.8125rem */;
  float: left;
}
.service-content:hover {
  color: #f77f00;
}
.service-left {
  width: 17.3125rem /* 277px -> 17.3125rem */;
  height: 20.625rem /* 330px -> 20.625rem */;
  background: #eceae3;
  margin: 1.25rem /* 20px -> 1.25rem */;
  float: left;
}
.service-right {
  width: 17.75rem /* 284px -> 17.75rem */;
  height: 8.75rem /* 140px -> 8.75rem */;
  margin: 1.25rem /* 20px -> 1.25rem */;
  float: left;
}
.service-right > div {
  height: 3rem /* 48px -> 3rem */;
  width: 17.75rem /* 284px -> 17.75rem */;
  margin: 5px 0;
}
.service-tel {
  width: 8.875rem /* 142px -> 8.875rem */;
  float: left;
}
.service-level {
  width: 8.875rem /* 142px -> 8.875rem */;
  float: left;
}
.service-allbed {
  width: 8.875rem /* 142px -> 8.875rem */;
  float: left;
}
.service-nonebed {
  width: 8.875rem /* 142px -> 8.875rem */;
  float: left;
}

.service-bottom {
  width: 17.25rem /* 276px -> 17.25rem */;
  margin: 0 7.1875rem /* 115px -> 7.1875rem */;
  height: 3.9375rem /* 63px -> 3.9375rem */;
  text-align: center;
  font-size: 1.25rem /* 20px -> 1.25rem */;
  line-height: 3.9375rem /* 63px -> 3.9375rem */;
  border-radius: 1.5625rem /* 25px -> 1.5625rem */;
  font-size: 1.5rem /* 24px -> 1.5rem */;
  background: dodgerblue;
  color: #fff;
  float: left;
}
.pageBtn {
  float: left;
  margin: .9375rem /* 15px -> .9375rem */ 0;
}
.apply {
  width: 21rem /* 336px -> 21rem */;
  height: 3.625rem /* 58px -> 3.625rem */;
  background: linear-gradient(90deg, #ffb71d, #f77f00);
  border-radius: 10px;
}
.el-pagination {
  width: 22.5rem /* 360px -> 22.5rem */;
  height: 2.1875rem /* 35px -> 2.1875rem */;
  margin-left: 29.375rem /* 470px -> 29.375rem */;
}
::v-deep .el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: #F77F00;
  color: #fff;
}
</style>
